/* eslint-disable prettier/prettier */
import Grid from '@elliemae/ds-grid';
import { DSSkeleton } from '@elliemae/ds-skeleton';
import { memo } from 'react';
import styled from 'styled-components';

const StyledGrid = styled(Grid)`
  @media (max-width: 1200px) {
    & > * {
      width: 3rem !important;
    }
  }
`;

export const MILoadingSkeleton = memo(function MILoadingSkeleton({
  hasEncApr,
}: {
  hasEncApr?: boolean;
}) {
  const width = hasEncApr === undefined ? '60px' : hasEncApr ? '96px' : '48px';
  return (
    <StyledGrid width="100%" justifyContent="flex-end">
      <DSSkeleton
        variant="rectangular"
        width={width}
        height="24px"
        data-testid="get-mi-skeleton"
      />
    </StyledGrid>
  );
});
